import { Link } from "../lib/router";
import { copy } from "../content/copy";

// A route that matches nothing is not an error page — it's a hall that hasn't
// been built. Bare scaffolding (pure CSS: a wireframe room in perspective and
// one balloon waiting inside it), the world-building done on screen, and one
// way back to the map. The SPA fallback serves this shell with a 200; the
// "404" is curatorial, not architectural.
export default function MissingHall() {
  return (
    <main className="missing">
      <p className="kicker">{copy.missing.kicker}</p>
      <div className="missing-room" aria-hidden="true">
        <div className="missing-wall missing-wall-back" />
        <div className="missing-wall missing-wall-floor" />
        <span className="missing-balloon">🎈</span>
      </div>
      <h1 className="missing-title">{copy.missing.title}</h1>
      <p className="missing-body">{copy.missing.body}</p>
      <Link to="/" className="cta">
        {copy.missing.cta}
      </Link>
    </main>
  );
}
